import React, { useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { useParams } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { activeStyles } from '../../consts/header'
import { scrollPageStop } from '../../helpers/scrollUtils'
import { getCookie, setCookie } from '../cookie/cookie'
import { Logo } from '../icons/Logo'
import { RedLogo } from '../icons/RedLogo'
import { BurgerMenu } from '../UI/BurgerMenu/BurgerMenu'
import styles from './header.module.scss'
import { HeaderTypes } from './Header.types'

export const Header = ({ isWhite }: HeaderTypes) => {
  const [active, setActive] = useState(false)
  const [componentToShow, setComponentToShow] = useState('')
  const { id } = useParams()
  const pageComponent = 'new'

  const handleClickBurger = () => {
    setActive(prev => {
      scrollPageStop(!prev)
      return !prev
    })
  }

  useEffect(() => {
    let selectedComponent = getCookie('BITRIX_SM_ab_design_code')

    if (!selectedComponent) {
      selectedComponent = Math.random() < 0.5 ? 'old' : 'new'
      setCookie('BITRIX_SM_ab_design_code', selectedComponent, 1)
    }

    setComponentToShow(selectedComponent)
  }, [])

  const handleRbkClick = (rbk: boolean) => {
    if (rbk) {
      ReactGA.ga('send', 'event', 'nav', 'rbc logo')
      ym('reachGoal', 'rbc_logo_header_click', {
        rbc_logo_header_click: 'click',
      })
    } else {
      ReactGA.ga('send', 'event', 'client link', 'logo header')
      ReactGA.ga('rbcspec.send', 'event', 'client link', 'click')
      ym('reachGoal', 'client link', {
        'client link': {
          'logo header':
            location.href.indexOf('collections') !== -1
              ? `Подборка ${id}`
              : location.href,
        },
      })
    }
  }

  const pikLogoLink =
    'https://www.pik.ru/?utm_source=rbc&utm_medium=display&utm_content=logo&erid=4CQwVszH9pUjpkbn9di'

  return (
    <>
      <div
        className={`
          ${styles.headerWrapper}
          ${isWhite ? styles['headerWrapper--white'] : ''}
          ${active && isWhite ? styles['headerWrapper--active'] : ''}
        `}
        style={active ? activeStyles : {}}
      >
        <div className={styles.rbkLogo}>
          <a
            href='https://rbc.ru/'
            target='_blank'
            onClick={() => handleRbkClick(true)}
          >
            <Logo />
          </a>
        </div>
        <div
          className={`${styles.burgerBtn} ${active ? styles.active : ''}`}
          onClick={handleClickBurger}
        >
          <span></span>
          <span></span>
        </div>
        <div className={styles.rightSideBlock}>
          <p
            className={styles.headerDescription}
            style={isWhite ? { color: 'white' } : { color: 'black' }}
          >
            совместный проект
          </p>
          <div className={styles.pikLogo}>
            <a
              href={pikLogoLink}
              target='_blank'
              onClick={() => handleRbkClick(false)}
            >
              <RedLogo />
            </a>
          </div>
        </div>
      </div>
      {active && (
        <BurgerMenu
          handleClickBurger={handleClickBurger}
          componentToShow={componentToShow}
          pageComponent={pageComponent}
        />
      )}
    </>
  )
}
